export function Avatar({
  name,
  url,
  size = 24,
  title,
}: {
  name: string;
  url?: string | null;
  size?: number;
  title?: string;
}) {
  const dim = { width: size, height: size };
  if (url) {
    return (
      <img
        src={url}
        alt={name}
        title={title ?? name}
        style={dim}
        className="rounded-full object-cover"
      />
    );
  }
  return (
    <span
      title={title ?? name}
      style={{ ...dim, fontSize: Math.max(9, Math.round(size * 0.42)) }}
      className="grid place-items-center rounded-full bg-accent/20 font-semibold text-accent"
    >
      {(name || "?").charAt(0).toUpperCase()}
    </span>
  );
}
